/**
 * Michelangelo Phase 2: Hook for hospital capability profile.
 */

import { useState, useEffect, useCallback } from 'react';
import hospitalCapabilityProfileService from '../services/hospitalCapabilityProfileService';

export function useCapabilityProfile(organizationId) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    if (!organizationId) {
      setProfile(null);
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      setError(null);
      const data = await hospitalCapabilityProfileService.getForOrganization(organizationId);
      setProfile(data);
    } catch (err) {
      console.error('useCapabilityProfile:', err);
      setError(err.message);
      setProfile(null);
    } finally {
      setLoading(false);
    }
  }, [organizationId]);

  useEffect(() => {
    load();
  }, [load]);

  return { profile, loading, error, refresh: load };
}
